import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from "react-redux";
import { addLead, resetLead } from "../../redux/actions-exporter";
import Button from "react-bootstrap/Button";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
// import SimpleItemList from "../repeats/itemList/SimpleItemList";
import WhereAndWhen from "../repeats/whereAndWhen/WhereAndWhen";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";
import Post from "../blog/Post";

import fewItems from "../../assets/images/TII/Two-Movers-With-Box-On-Stairca-97352312.jpg";
import galleryImg1 from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";
import galleryImg2 from "../../assets/images/TII/iStock-467917955.jpg";
import galleryImg3 from "../../assets/images/TII/moving-company-insurance.jpg";
import galleryImg4 from "../../assets/images/TII/moving-service-worker-sealing-cardboard-box-GRM5SEC.jpg";
import galleryImg5 from "../../assets/images/TII/packing-furniture-moving-service.jpg";
import galleryImg6 from "../../assets/images/TII/Two-Movers-With-Box-On-Stairca-97352312.jpg";
import img1 from "../../assets/images/Blog/1.jpg";
import "./TransportFewItems.css";
// import { parseISO } from "date-fns";

const LEAD_SOURCE = "הובלת פריטים בודדים";

const TransportFewItems = ({ mainLogo }) => {
  // Bootstrap validation
  const [validated, setValidated] = useState(false);
  const addedLead = useSelector((state) => state.lead.addedLead);
  const [form, setForm] = useState({ source: LEAD_SOURCE, extraFields: {} });
  const [send, setSend] = useState(false);
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);
  const [fromaddress, setFromaddress] = useState("");
  const [toaddress, setToaddress] = useState("");
  const [moveDate, setMoveDate] = useState("");

  useEffect(() => {
    if (start || send) document.querySelector(".homeTitle").scrollIntoView();
    setStart(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [send]);

  const handleOnPlaceSelected = (place, inputRefTo) => {
    if (inputRefTo.name === "fromaddress") {
      setFromaddress(place.formatted_address);
    } else if (inputRefTo.name === "toaddress") {
      setToaddress(place.formatted_address);
    }
  };

  useEffect(() => {
    if (addedLead) {
      setSend(true);
      setForm({ source: LEAD_SOURCE });
      dispatch(resetLead());
    }
  }, [addedLead]); // eslint-disable-line

  useEffect(() => {
    setForm({ ...form, extraFields: { fromaddress, toaddress } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromaddress, toaddress]);

  const onDateChange = (date, field) => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        [field]: date,
      },
    });
    setMoveDate(date);
  };

  const onExtrafieldsChange = (e) => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        [e.target.name]: e.target.value,
      },
    })
  }

  const handleSend = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      dispatch(addLead(form, "only_delivery"));
    }
    setValidated(true);
  };


  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  return (
    <div className="transportFewItems">
      <div className="page_banner">
        <img src={fewItems} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הובלת פריטים בודדים</h1>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transport" />
            <MainBtn
              text="הובלת דירות ובתים"
              link="/transportapartment"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">הובלת פריטים בודדים</h1>
        <div className="splitDiv">
          <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div>

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרת בנו!"
                text2="נציג יחזור אליך בהקדם"
              />
            ) : (
              <>
                <Form
                  className="formBox"
                  noValidate
                  validated={validated}
                  onSubmit={handleSend}
                >
                  <WhereAndWhen
                    onChange={onExtrafieldsChange}
                    onDateChange={onDateChange}
                    handleOnPlaceSelected={handleOnPlaceSelected}
                    moveDate={moveDate}
                  />

                  <Row className="mb-3 row">
                    <Form.Group className="mb-3 text" controlId="formBasicList">
                      <Form.Label className="fw-semibold mb-2">
                        רשימת פריטים
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        as="textarea"
                        placeholder="שמות הפריטים..."
                        name="positions"
                        onChange={onExtrafieldsChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        נא להכניס פריט אחד לפחות
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <Row className="mb-3 row">
                    <Form.Group
                      as={Col}
                      className="mb-3"
                      controlId="formBasicFile"
                    >
                      <Form.Label className="fw-semibold mb-2">
                        העלאת תמונות או וידאו (לא חובה)
                      </Form.Label>
                      <Form.Control
                        type="file"
                        placeholder="בחר קובץ"
                        name="image"
                        onChange={onExtrafieldsChange}
                      />
                    </Form.Group>
                  </Row>

                  <PersonalDetails
                    onChange={(field) => setForm({ ...form, ...field })}
                  />

                  {/* <div className="contact-btnDiv row"> */}
                  {/* <MainBtn text="שליחה" handleSend={onAddOrder} type="submit" /> */}
                  <Button
                    style={{
                      background: "var(--primary)",
                      border: "none",
                      width: "100%",
                    }}
                    text="שליחה"
                    type="submit"
                    className="filter-btn"
                  >
                    שליחה
                  </Button>
                  {/* </div> */}
                </Form>
              </>
            )}
          </div>
        </div>
      </div>

      <Reviews />

      <div className="articlesDiv">
        <Post
          title="טיפים לאריזה"
          img={img1}
          text="  לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק. קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק. קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח.לת צשחמי מוסן מנת.להאמית קרהשק סכעיט דז מא, מנכם למטכין נשואי מנורך.קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.         קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח.עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף ליבם סולגק.בראיט ולחת צורק מונחף, בגורמי מגמש.תרבנך וסתעד לכנו סתשם השמה - לתכי מורגם בורק ? לתיג ישבעס.        קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף.זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק."
        />
      </div>

      <Footer />
    </div>
  );
};

export default TransportFewItems;
